/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VmTypeListSchema } from './VmTypeListSchema';
import {
    VmTypeListSchemaFromJSON,
    VmTypeListSchemaFromJSONTyped,
    VmTypeListSchemaToJSON,
} from './VmTypeListSchema';

/**
 * 
 * @export
 * @interface PagedVmTypeListSchema
 */
export interface PagedVmTypeListSchema {
    /**
     * 
     * @type {Array<VmTypeListSchema>}
     * @memberof PagedVmTypeListSchema
     */
    items: Array<VmTypeListSchema>;
    /**
     * 
     * @type {number}
     * @memberof PagedVmTypeListSchema
     */
    count: number;
}

/**
 * Check if a given object implements the PagedVmTypeListSchema interface.
 */
export function instanceOfPagedVmTypeListSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function PagedVmTypeListSchemaFromJSON(json: any): PagedVmTypeListSchema {
    return PagedVmTypeListSchemaFromJSONTyped(json, false);
}

export function PagedVmTypeListSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedVmTypeListSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(VmTypeListSchemaFromJSON)),
        'count': json['count'],
    };
}

export function PagedVmTypeListSchemaToJSON(value?: PagedVmTypeListSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(VmTypeListSchemaToJSON)),
        'count': value.count,
    };
}

